import { useContext } from "react";
import { DeductionIncompleteContext } from "../context/DeductionIncompleteContext";

export default function useDeductionIncomplete() {
  const context = useContext(DeductionIncompleteContext);
  if (!context) throw new Error("useDeductionIncompleteContext must be used within a DeductionIncompleteProvider.");
  return context;
}
